module.exports = __webpack_public_path__ + "static/media/b5.83d2a083.png";